module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path d=\"M64 144h384v32H64zM64 240h384v32H64zM64 336h384v32H64z\"/></svg>"